module.exports = __webpack_public_path__ + "img/portable_game.e00a0d43.webp";